// extracted by mini-css-extract-plugin
export default {"tupacGrid":"mo-z","tupacHeader":"no-z","tupacHeader2":"oo-z","tupacMenu":"po-z","tupacMenu2":"qo-z","tupacMain":"ro-z","tupacMain2":"so-z"};